<script setup lang="ts">
import { ref, watch, type PropType } from 'vue';
import Textarea from 'primevue/textarea';
import { type FormField, FormFieldType } from '@/models';
import InputNumber from 'primevue/inputnumber';

const props = defineProps({
  field: {
    type: Object as PropType<FormField>,
    required: true
  },
  previewMode: {
    type: Boolean
  }
});

const localField = ref<FormField>(props.field);

const onInputeChange = () => {
  localField.value.inputChanged = true;
};

watch(() => localField.value.numberValue, newValue => {
  if (newValue) {
    localField.value.inputChanged = true;
  }
});
</script>

<template>
  <div class="item-root">
    <InputNumber id="input"
      v-model="localField.numberValue"
      v-if="localField.type === FormFieldType.NUMBER"
      :disabled="previewMode"
      mode="decimal"
      :maxFractionDigits="20"/>
    <Textarea v-model="localField.value"
      autoResize
      v-if="localField.type === FormFieldType.TEXT"
      rows="1"
      @input="onInputeChange"
      :disabled="previewMode"
      class="text-input"/>
  </div>
</template>

<style scoped lang="scss">
.item-root {
    .text-input {
        width: 100%;
        min-height: 38px;
    }
}
</style>
